import { Box, type BoxProps, type Theme } from "@mui/material";
import { mergeSxProps } from "@src/appV2/lib";

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface FloatingNavigationItemWrapperProps extends BoxProps {}

/**
 * Floating navigation item wrapper that appears in the bottom of the page
 */
export function FloatingNavigationItemWrapper(props: FloatingNavigationItemWrapperProps) {
  const { sx, ...restProps } = props;

  return (
    <Box
      sx={mergeSxProps(
        (theme: Theme) => ({
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          alignItems: "center",
          bottom: theme.size?.floatingNavigation.margin,
          position: "fixed",
          gap: 3,
          padding: 2,
          opacity: 1,
          color: theme.palette.text.invert,
          height: theme.size?.floatingNavigation.height,
          background: theme.palette.floatingNavigation!.background,
          userSelect: "none",
          outline: "1px solid #585858",
          boxShadow: theme.shadow?.floatingNavigation,
          borderRadius: theme.borderRadius?.xxxLarge,
          cursor: "pointer",
          zIndex: theme.zIndex.fab,
        }),
        sx
      )}
      {...restProps}
    />
  );
}
